module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/public_sciences/1-2376a33373d2d2883a842a3b6b0c65af.jpg";